import slide1 from "../Sliderimg/home-hero4.jpg";
import slide2 from "../Sliderimg/home-hero2.jpg";
import slide5 from "../Sliderimg/home-hero3.jpg";
import slide4 from "../Sliderimg/home-hero1.jpg";
import slide3 from "../Sliderimg/home-hero-5.webp";

const SliderItems = [
  {
    id: 1,
    // title: "Making Web Dreams a Reality, Every Day.",
    image: slide1,
  },
  {
    id: 2,
    // title: "We Create, You Conquer",
    image: slide2,
  },
  {
    id: 3,
    // title: "Connecting You Everywhere",
    image: slide3,
  },
  {
    id: 4,
    // title: "Teams make dreams and more",
    image: slide4,
  },
  { id: 5, 
    // title: "A fresh new look for your site", 
    image: slide5 },
];

export default SliderItems;
